import React from 'react';
import api from '../api';
import getAzureSasToken from '../../utils/azureSasToken';

const DownloadImage = ({ fileId, idRede }) => {
    const apiUrl = process.env.REACT_APP_API_BASE_33;
    const azureSasToken = getAzureSasToken();

    const isAbsoluteHttpUrl = (value) => /^https?:\/\//i.test(value || '');
    const getViewableBlobUrl = (url) => {
        if (!url) return '';
        if (url.includes('blob.core.windows.net') && !url.includes('?') && azureSasToken) {
            return `${url}${azureSasToken}`;
        }
        return url;
    };

    const handleDownload = async () => {


        try {
            if (isAbsoluteHttpUrl(fileId)) {
                const directUrl = getViewableBlobUrl(fileId);
                const link = document.createElement('a');
                link.href = directUrl;
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                link.download = '';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                return;
            }

            // Realiza a solicitação para o endpoint de download
            const response = await api.get(`${apiUrl}/download/${fileId}?id_rede=${idRede}`, {
                responseType: 'blob', // Necessário para lidar com arquivos binários
            });

            // Cria um URL para o blob recebido
            const downloadUrl = URL.createObjectURL(response.data);


            // Cria um link temporário para realizar o download
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = `imagem_${fileId}.png`; // Nome do arquivo baixado


            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);


        } catch (error) {
            console.error('Erro ao tentar realizar o download:', error); // Log em caso de erro
        }
    };

    return (
        <div>
            <button onClick={handleDownload}>Download</button>
        </div>
    );
};

export default DownloadImage;
